var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRotas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 10V8.75H36.875V0.625H35.625V21.25C35.625 27.1087 30.8587 31.875 25 31.875H11.875V29.375H13.75V28.125H11.875V25.625H23.75C26.8512 25.625 29.375 23.1012 29.375 20V0.625H28.125V8.75H15C8.45187 8.75 3.125 14.0769 3.125 20.625V24.375H0.625V25.625H3.125V31.875H0.625V33.125H3.125V39.375H4.375V20.625C4.375 14.7663 9.14125 10 15 10H28.125V12.5H27.5V13.75H28.125V16.25H16.25C13.1488 16.25 10.625 18.7738 10.625 21.875V39.375H11.875V33.125H25C27.0681 33.125 29.0131 32.5912 30.7081 31.6575C30.655 31.9306 30.625 32.2119 30.625 32.5C30.625 33.8581 31.1119 35.1744 31.9956 36.2056L34.5256 39.1569C34.6444 39.2956 34.8175 39.375 35 39.375C35.1825 39.375 35.3556 39.2956 35.4744 39.1569L38.0044 36.2056C38.8881 35.1744 39.375 33.8581 39.375 32.5C39.375 30.0875 37.4125 28.125 35 28.125C34.8825 28.125 34.7669 28.1337 34.6513 28.1425C36.045 26.1969 36.875 23.8206 36.875 21.25V17.5H39.375V16.25H36.875V10H39.375ZM16.25 17.5H28.125V20C28.125 22.4125 26.1625 24.375 23.75 24.375H11.875V21.875C11.875 19.4625 13.8375 17.5 16.25 17.5ZM38.125 32.5C38.125 33.56 37.745 34.5869 37.0556 35.3919L35 37.7894L32.9444 35.3919C32.255 34.5869 31.875 33.56 31.875 32.5C31.875 30.7769 33.2769 29.375 35 29.375C36.7231 29.375 38.125 30.7769 38.125 32.5Z",
    fill: "#E7973E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3863 14.2413C9.68313 14.7675 9.06438 15.3944 8.54688 16.1044L9.55688 16.8406C10.0006 16.2313 10.5319 15.6931 11.135 15.2413L10.3863 14.2413Z",
    fill: "#E7973E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 23.4662H8.125V25.9081H6.875V23.4662Z",
    fill: "#E7973E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87817 21.0075L8.12755 21.0419C8.14817 20.2856 8.2813 19.5425 8.52317 18.8325L7.33942 18.4294C7.05755 19.2581 6.90192 20.1263 6.87817 21.0075Z",
    fill: "#E7973E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 28.3494H8.125V30.7912H6.875V28.3494Z",
    fill: "#E7973E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 33.2331H8.125V35.675H6.875V33.2331Z",
    fill: "#E7973E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6169 12.5H25.0588V13.75H22.6169V12.5Z",
    fill: "#E7973E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7332 12.5H20.175V13.75H17.7332V12.5Z",
    fill: "#E7973E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2663 12.5075C14.3857 12.5431 13.5207 12.7094 12.6951 13.0025L13.1132 14.1806C13.8207 13.9294 14.5619 13.7869 15.3163 13.7563L15.2663 12.5075Z",
    fill: "#E7973E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 38.125H8.125V39.375H6.875V38.125Z",
    fill: "#E7973E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M32.375 24.1731L31.2325 23.6656C30.92 24.3687 30.5019 25.0187 29.9888 25.5981L30.9244 26.4268C31.5225 25.7525 32.0106 24.9937 32.375 24.1731Z",
    fill: "#E7973E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1249 20.625V19.0181H31.8749V20.6256C31.8749 20.8994 31.8606 21.1756 31.8306 21.4475L33.0731 21.5838C33.1081 21.2663 33.1249 20.9431 33.1249 20.625Z",
    fill: "#E7973E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 4.01813H33.125V6.51813H31.875V4.01813Z",
    fill: "#E7973E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 14.0181H33.125V16.5181H31.875V14.0181Z",
    fill: "#E7973E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 9.01813H33.125V11.5181H31.875V9.01813Z",
    fill: "#E7973E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 0.625H33.125V1.51812H31.875V0.625Z",
    fill: "#E7973E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 28.125H23.75V29.375H21.25V28.125Z",
    fill: "#E7973E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3757 29.145C27.2513 28.94 28.0876 28.6019 28.8619 28.1387L28.2207 27.0656C27.5576 27.4625 26.8407 27.7525 26.0913 27.9275L26.3757 29.145Z",
    fill: "#E7973E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 28.125H18.75V29.375H16.25V28.125Z",
    fill: "#E7973E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52563 11.6569C4.64438 11.7956 4.8175 11.875 5 11.875C5.1825 11.875 5.35562 11.7956 5.47437 11.6569L8.00437 8.70562C8.88813 7.67438 9.375 6.35813 9.375 5C9.375 2.5875 7.4125 0.625 5 0.625C2.5875 0.625 0.625 2.5875 0.625 5C0.625 6.35813 1.11188 7.67438 1.99563 8.70562L4.52563 11.6569ZM5 1.875C6.72312 1.875 8.125 3.27688 8.125 5C8.125 6.06 7.745 7.08687 7.05562 7.89187L5 10.2894L2.94438 7.89187C2.255 7.08687 1.875 6.06 1.875 5C1.875 3.27688 3.27688 1.875 5 1.875Z",
    fill: "#E7973E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.875C6.03375 6.875 6.875 6.03375 6.875 5C6.875 3.96625 6.03375 3.125 5 3.125C3.96625 3.125 3.125 3.96625 3.125 5C3.125 6.03375 3.96625 6.875 5 6.875ZM5 4.375C5.34437 4.375 5.625 4.65562 5.625 5C5.625 5.34437 5.34437 5.625 5 5.625C4.65562 5.625 4.375 5.34437 4.375 5C4.375 4.65562 4.65562 4.375 5 4.375Z",
    fill: "#E7973E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35 34.375C36.0338 34.375 36.875 33.5338 36.875 32.5C36.875 31.4662 36.0338 30.625 35 30.625C33.9662 30.625 33.125 31.4662 33.125 32.5C33.125 33.5338 33.9662 34.375 35 34.375ZM35 31.875C35.3444 31.875 35.625 32.1556 35.625 32.5C35.625 32.8444 35.3444 33.125 35 33.125C34.6556 33.125 34.375 32.8444 34.375 32.5C34.375 32.1556 34.6556 31.875 35 31.875Z",
    fill: "#E7973E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotas);
export default __webpack_public_path__ + "static/media/iconRotas.e724f70749e6727657a91542ac9fbdb2.svg";
export { ForwardRef as ReactComponent };